import { getDataAPI, postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Admin actions for the center fees and the payments screen.
 */

const adminToken = () => localStorage.getItem("adminToken");

/** Base for links that open in a browser tab (PDF receipts). */
export const FILE_BASE = "https://nsvec.com/api/public/";

const query = (params, keys) => {
  const q = new URLSearchParams();
  keys.forEach((key) => {
    const value = params[key];
    if (value !== undefined && value !== "" && value !== "all") {
      q.append(key, value);
    }
  });
  const s = q.toString();
  return s ? `?${s}` : "";
};

/** The amounts admin has set, plus the list of payment channels. */
export const getCenterFeeSetting = () => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI("admin/center-fee/setting", adminToken())
    );
    return response ? response.data.data : false;
  } catch (error) {
    return false;
  }
};

/** Save the registration full/partial amounts and the yearly renewal amount. */
export const saveCenterFeeSetting = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/center-fee/setting", data, adminToken())
    );
    if (response) {
      successAlert(response.data.message);
      return response.data.data;
    }
    return false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not save the center fee."
    );
    return false;
  }
};

/** Approved centers with what they owe and when they renew. */
export const getCenterFeeList = (params = {}) => async (dispatch) => {
  try {
    const suffix = query(params, ["search", "filter", "page", "per_page"]);
    const response = await dispatch(
      getDataAPI(`admin/center-fee/list${suffix}`, adminToken())
    );
    return response ? response.data.data : false;
  } catch (error) {
    return false;
  }
};

/** One center's fee position plus its payment history. */
export const getCenterFeeDetails = (id) => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI(`admin/center-fee/details/${id}`, adminToken())
    );
    return response ? response.data.data : false;
  } catch (error) {
    return false;
  }
};

/** Record a payment received outside the website. */
export const addOfflineCenterFee = (data) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI("admin/center-fee/offline", data, adminToken())
    );
    if (response) {
      successAlert(response.data.message);
      return response.data.data;
    }
    return false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not record the payment."
    );
    return false;
  }
};

/**
 * Set when a center's next renewal falls due. Needed for centers that existed
 * before renewals, whose date is only a guess until admin corrects it.
 */
export const setCenterRenewalDate = (centerId, date) => async (dispatch) => {
  try {
    const form = new FormData();
    form.append("center_id", centerId);
    form.append("renewal_date", date);
    const response = await dispatch(
      postDataAPI("admin/center-fee/renewal-date", form, adminToken())
    );
    if (response) {
      successAlert(response.data.message);
      return response.data.data;
    }
    return false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not update the renewal date."
    );
    return false;
  }
};

/** Remove a payment entered by mistake. Gateway payments are refused. */
export const deleteCenterFeePayment = (id) => async (dispatch) => {
  try {
    const form = new FormData();
    form.append("id", id);
    const response = await dispatch(
      postDataAPI("admin/center-fee/delete", form, adminToken())
    );
    if (response) {
      successAlert(response.data.message);
      return response.data.data;
    }
    return false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "Could not remove the payment."
    );
    return false;
  }
};

const PAYMENT_KEYS = [
  "type",
  "mode",
  "status",
  "search",
  "from",
  "to",
  "page",
  "per_page",
];

/** Student, exam, center and renewal payments in one list. */
export const getPayments = (params = {}) => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI(`admin/payments${query(params, PAYMENT_KEYS)}`, adminToken())
    );
    return response ? response.data.data : false;
  } catch (error) {
    return false;
  }
};

/** Everything matching the filters, unpaged, for the Excel export. */
export const getAllPayments = (params = {}) => async (dispatch) => {
  try {
    const response = await dispatch(
      getDataAPI(
        `admin/payments/export${query(params, PAYMENT_KEYS)}`,
        adminToken()
      )
    );
    return response ? response.data.data : false;
  } catch (error) {
    errorAlert("Could not build the export.");
    return false;
  }
};
